<template>
    <vx-expandable-card>
        <template v-slot:header>Content</template>
        <template v-slot:content>
            <div class="flex flex-col gap-3">
                <vx-tabs v-model="mode" size="lg" role="tablist" aria-label="Write or preview">
                    <vx-tab value="write" :id="writeTabId" :aria-controls="writePanelId" data-test="content-tab-write">
                        Write
                    </vx-tab>
                    <vx-tab
                        value="preview"
                        :id="previewTabId"
                        :aria-controls="previewPanelId"
                        data-test="content-tab-preview"
                    >
                        Preview
                    </vx-tab>
                </vx-tabs>

                <div v-show="mode === 'write'" :id="writePanelId" role="tabpanel" :aria-labelledby="writeTabId">
                    <vx-input
                        v-model="data.content"
                        size="lg"
                        :rows="16"
                        :maxlength="65535"
                        :counter="true"
                        :disabled="!props.canEdit"
                        data-test="content-input"
                        :error="displayFirstError(validation.content.$errors)"
                    />
                    <div class="text-xs text-slate-500 mt-1">Markdown supported.</div>
                </div>

                <div
                    v-show="mode === 'preview'"
                    :id="previewPanelId"
                    role="tabpanel"
                    :aria-labelledby="previewTabId"
                    class="min-h-[24rem]"
                    data-test="content-preview"
                >
                    <markdown-renderer v-if="data.content" :source="data.content" />
                    <div v-else class="text-sm text-slate-400 italic">Nothing to preview yet.</div>
                </div>
            </div>
        </template>
    </vx-expandable-card>
</template>

<script lang="ts" setup>
import { VxExpandableCard, VxInput, VxTab, VxTabs } from '@voxie/frontend-components';
import { ref, useId } from 'vue';
import { maxLength, required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import { displayFirstError } from '~/utils/validation';
import MarkdownRenderer from '~/components/general/MarkdownRenderer.vue';
import type { TermFormData } from '~/services/adminTermsClient.types';

const props = defineProps<{
    canEdit: boolean;
}>();

const data = defineModel<TermFormData>({ required: true });

const mode = ref<'write' | 'preview'>('write');
const writeTabId = useId();
const previewTabId = useId();
const writePanelId = useId();
const previewPanelId = useId();

const validation = useVuelidate(
    {
        content: { required, maxLength: maxLength(65535) },
    },
    data
);
</script>
